import { render, staticRenderFns } from "./TweetDisplay.vue?vue&type=template&id=c6ef1df2&scoped=true&"
import script from "./TweetDisplay.vue?vue&type=script&lang=js&"
export * from "./TweetDisplay.vue?vue&type=script&lang=js&"
import style0 from "./TweetDisplay.vue?vue&type=style&index=0&id=c6ef1df2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ef1df2",
  null
  
)

export default component.exports